import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { AmbikaVenderApi } from './config';

const Profile = () => {
    const [profile,setProfile] = useState()
    const ambikaDriverToken = localStorage.getItem("ambikaDriverToken");
    const ambikaDriverId = localStorage.getItem("ambikaDriverId"); 
    const navigate = useNavigate()
    

    useEffect(() => {
        axios.get(`${AmbikaVenderApi}/vendor/profile`, { headers: { Authorization: `Bearer ${ambikaDriverToken}` } })
        .then((res)=>{
      
            setProfile(res?.data?.data);
        })
        .catch((err)=>{
            // console.log(err);
        })
    }, [ambikaDriverToken, ambikaDriverId])


  return (
    <div>
               <div className='col-lg-6 col-md-8 col-11 m-auto mt-5 '>
                  <div className='row border text-start p-1'>
                    <div className='col-4'>Name</div>
                    <div className='col-8'>: {profile?.name}</div> 
                  </div>
                  <div className='row border text-start p-1'>
                    <div className='col-4'>Number</div>
                    <div className='col-8'>: {profile?.phone}</div> 
                  </div>
                  <div className='row border text-start p-1'>
                    <div className='col-4'>Email</div>
                    <div className='col-8'>: {profile?.email}</div> 
                  </div>
                  <div className='row border text-start p-1'>
                    <div className='col-4'>Address</div>
                    <div className='col-8'>: {profile?.address}</div> 
                  </div>
                  <div className='row border text-start p-1'>
                    <div className='col-4'>City</div>
                    <div className='col-8'>: {profile?.city}</div> 
                  </div>
                  <div className='row border text-start p-1'>
                    <div className='col-4'>Zip</div>
                    <div className='col-8'>: {profile?.zip}</div> 
                  </div>
                  <div className='row border text-start p-1'>
                    <div className='col-4'>Date of Birth</div>
                    <div className='col-8'>: {profile?.dob}</div> 
                  </div>
                  <div className='row border text-start p-1'>
                    <div className='col-4'>Blood Group</div>
                    <div className='col-8'>: {profile?.blood_group}</div> 
                  </div>


                </div>
    </div>
  )
}

export default Profile